import { render, staticRenderFns } from "./InfoDataRFQ3.vue?vue&type=template&id=a9ef1be2&"
import script from "./InfoDataRFQ3.vue?vue&type=script&lang=js&"
export * from "./InfoDataRFQ3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports